export default {
  colors: {
    greyLight: '#f8f8f8',
    greyDark: '#666',
    red: '#bf1c1c',
    white: '#fff',
    blue: '#108ee9',
    pink: '#f69899',
    green: '#64ea91',
    yellow: '#f8c82e',
    blueLight: '#8fc9fb',
    newBlueLight: '#60A5FA',
    blueDark: '#00008B',
    newBlueDark: '#1E40AF',
    orange: '#f0934e',
    greenDark: '#16a085',
    pieChartBrightest: '#dbeafe',
    pieChartDarkest: '#1E3A8A'
  },
  h1: {
    marginBottom: '1em',
    fontSize: '1.5rem'
  }
};
